import { api } from '@/api/main.api'

export async function apiCreateProject (userRole, data) {
  const endpoint = userRole === 'admin' ? 'adminCreate' : 'create'
  return api('post', `/v3/project/${endpoint}`, data)
}

export async function apiGetListCustomers () {
  return api('get', '/profile/listCustomers')
}

export async function apiGetProject (projectID) {
  return api('get', `/v3/project/get/${projectID}`)
}

export async function apiUpdateProject (projectSettings) {
  return api('post', '/v3/project/adminUpdate', projectSettings)
}

// TODO add add, delete project

export async function apiProjectTaskCreate (task) {
  return api('post', '/v3/project/task', task)
}

export async function apiProjectTaskRemove (projectID, id) {
  return api('delete', `/v3/project/${projectID}/task/${id}`)
}

export async function apiUpdateUserTaskOrder (taskSortType) {
  return api('post', `/v3/project/updateUserTaskOrder?sortType=${taskSortType}`)
}

export async function apiUpdateUserCustomTaskOrder (projectID, dragedTaskList) {
  return api('post', `/v3/project/${projectID}/tasks/reorder`, {tasks: dragedTaskList})
}

export async function apiGetTasks (projectID, sortType, cursor) {
  return api('get', `/v3/project/get/${projectID}/tasks?sort=${sortType}&limit=10&cursor=${cursor}`)
}

export async function apiGetArchivedTasks (projectID, cursor) {
  return api('get', `/v3/project/get/${projectID}/archived-tasks?limit=10&cursor=${cursor}`)
}

// TODO task update, get active list pagination

export async function apiProjectUserInvite (user) {
  return api('post', '/v3/project/inviteUserToProject', user)
}

export async function apiProjectUserRemove (projectID, id) {
  return api('delete', `/v3/project/${projectID}/user/${id}`)
}

export async function apiProjectChatInit (projectID) {
  return api('get', `/chat/channel/${projectID}/init`)
}

export async function apiProjectUpdateClientCharacterNotes (data) {
  return api('post', '/v3/project/updateClientCharacterNotes/', data)
}

export async function apiProjectNotificationsSeen (projectID) {
  return api('post', `/v3/project/notificationsSeen?id=${projectID}`)
}

export async function apiStripeConfirmSubscription (projectID, sessionId) {
  return api('post', `/v3/project/stripe-payment/confirm-subscription?id=${projectID}&sessionId=${sessionId}`)
}

export async function apiStripeConfirmPayAsYouGo (projectID, sessionId) {
  return api('post', `/v3/project/stripe-payment/confirm-pay-as-you-go-plan?id=${projectID}&sessionId=${sessionId}`)
}

export async function apiGetUserProjects (cursor) {
  return api('get', `/v3/project/list-names?limit=20&cursor=${cursor}`)
}

export async function apiGetProjectDesigners (projectId, taskId) {
  return api('get', `/v3/project/list-available-designer?projectId=${projectId}&taskId=${taskId}`)
}

export async function apiPingJob (projectId, taskId) {
  return api('get', `/v3/project/${projectId}/task/${taskId}/getZipLink`)
}

export async function apiManualSetupPaymentPlan (projectId, paymentPlan, paymentPlanCurrentPeriodEnd) {
  return api('post', `/v3/project/${projectId}/manual-setup-payment-plan`, {paymentPlan, paymentPlanCurrentPeriodEnd})
}

export async function apiUserRemoveAllInformation () { // check project id param
  return api('post', '/v3/project/gdprRequest')
}

export async function apiPaymentExecute (id, paymentPlan) { // check project id param
  return api('post', `/v3/project/stripe-payment/create-subscription?id=${id}&paymentPlan=${paymentPlan}`)
}

export async function apiUpdateFeedback (projectId, taskId, designerFileUuid, feedback) {
  return api('post', `/v3/design-feedback/${projectId}/${taskId}/${designerFileUuid}`, feedback)
}



// WEBPACK FOOTER //
// ./src/api/project.api.js